import React from 'react'
import OutOfRegion from './OutOfRegion'

const OutOfRegionContainer = props => <OutOfRegion {...props} />

OutOfRegionContainer.getInitialProps = async ({ query, playerApi }) => {
  const title = ''
  const description = ''
  return {
    title,
    description,
    showWallpaper: false,
    layout: 'landing-page',
  }
}

export default OutOfRegionContainer
